import React from "react";
import PropTypes from "prop-types";

const ResourceCard = ({ url, title, image, excerpt, topics, altText }) => {

	const placeholder = "/wp-content/themes/fords/dist/images/png/graphics/placeholder-lrg@2x.png";

	return (
		<div className="resource-card animate-hover">
			<a href={url}>
				<div className="resource-card__wrapper">
					<div className="resource-card__image">
						<div className="aspect-ratio-box">
							<img src={image ? image : placeholder} alt={altText}/>
						</div>
					</div>
					<div className="resource-card__content">
						<div className="resource-card__content__category-tags">
							{topics.map((topic) => (
								<span key={topic} dangerouslySetInnerHTML={{__html: topic }}/>
							))}
						</div>
						<h3 className="h4 resource-card__content__title hover-title" dangerouslySetInnerHTML={{__html: title}}/>
						<p className="resource-card__content__excerpt" dangerouslySetInnerHTML={{__html: excerpt}} />
					</div>
				</div>
			</a>
		</div>
	);
};

export default ResourceCard;

ResourceCard.propTypes = {
	title: PropTypes.string,
	types: PropTypes.string,
	url: PropTypes.string,
	image: PropTypes.string,
	excerpt: PropTypes.string,
	categories: PropTypes.array,
};
